import React from 'react'
import DownloadIcon from '@src/icons/DownloadIcon'
import { makeStyles } from '@material-ui/core/styles'
import { Theme, Link, Grid } from '@material-ui/core'
import messages from '../../../messages'
import { FormattedMessage } from 'react-intl'
import { ProductType } from '../enum'

const useStyles = makeStyles((theme: Theme) => {
  return {
    multiProductTemplateIcon: {
      color: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightBold,
      display: 'flex',
      alignItems: 'center',
    },
    multiProductTemplateText: {
      fontSize: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightBold,
      color: theme.palette.primary.main,
      marginLeft: theme.spacing(2),
      fontFamily: 'Lato',
    },
    multiProductTemplateButton: {
      borderRadius: 0,
      '&:hover': {
        background: 'none',
        textDecoration: 'underline',
      },
    },
    downloadItem: {
      marginBottom: theme.spacing(4),
    },
  }
})
const LinkContent = ({ url, label }) => {
  const classes = useStyles()
  return (
    <Link className={classes.multiProductTemplateButton} download href={url}>
      <div className={classes.multiProductTemplateIcon}>
        <DownloadIcon />
        <span className={classes.multiProductTemplateText}>{label}</span>
      </div>
    </Link>
  )
}

const DownloadTemplate = (props) => {
  const classes = useStyles()
  const { productDetails } = props
  const linkUrl = (type: string) =>
    `/configurator-upload/upload/bulk-entry/template/${type}/${productDetails.countryCode}?isCSR=${productDetails.isCSR}`
  if (productDetails.type === ProductType.NgsoPlates) {
    const links = [
      {
        name: ProductType.NGSO_Plate_8ch,
        label: (
          <FormattedMessage
            id="CONF_DOWNLOAD_TEMPLATE_STANDARD_8_CHANNEL"
            defaultMessage="96 well, 8 channel, standard"
          />
        ),
      },
      {
        name: ProductType.NGSO_Plate_12ch,
        label: (
          <FormattedMessage
            id="CONF_DOWNLOAD_TEMPLATE_STANDARD_12_CHANNEL"
            defaultMessage="96 well, 12 channel, standard"
          />
        ),
      },
      {
        name: ProductType.NGSO_Plate_8ch_mixed,
        label: (
          <FormattedMessage
            id="CONF_DOWNLOAD_TEMPLATE_MIXED_8_CHANNEL"
            defaultMessage="96 well, 8 channel, mixed"
          />
        ),
      },
      {
        name: ProductType.NGSO_Plate_12ch_mixed,
        label: (
          <FormattedMessage
            id="CONF_DOWNLOAD_TEMPLATE_MIXED_12_CHANNEL"
            defaultMessage="96 well, 12 channel, mixed"
          />
        ),
      },
    ]

    return (
      <>
        {links.map((link, index) => (
          <Grid xs={6} className={classes.downloadItem} key={index}>
            <LinkContent url={linkUrl(link.name)} label={link.label} />
          </Grid>
        ))}
      </>
    )
  } else {
    //return single download link for tube
    return (
      <div>
        <LinkContent
          url={linkUrl(productDetails.type)}
          label={
            <FormattedMessage {...messages.CONF_NGSO_DOWNLOAD_TUBE_TEMPLATE} />
          }
        />
      </div>
    )
  }
}

export default DownloadTemplate
